import script from "./myDataView.vue?vue&type=script&setup=true&lang=ts"
export * from "./myDataView.vue?vue&type=script&setup=true&lang=ts"

import "./myDataView.vue?vue&type=style&index=0&id=6680f8f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6680f8f6"]])

export default __exports__